import React from "react";
import _ from "underscore";
import img from '~/assets/icn-cancel-copy.svg';
import toastr from 'toastr';
import { convertFieldName} from "~/app/utilities";

class LineItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      claim: null,
      line_items: 0,
      fields: {
        diag_1: null,
        diag_2: null,
        diag_3: null,
        diag_4: null,
        diag_5: null,
        proc_code_1: null,
        proc_code_2: null,
        proc_code_3: null,
        proc_code_4: null,
        proc_code_5: null,
        units_1: null,
        units_2: null,
        units_3: null,
        units_4: null,
        units_5: null,
        charge_1: null,
        charge_2: null,
        charge_3: null,
        charge_4: null,
        charge_5: null,
        mod1_1: null,
        mod1_2: null,
        mod1_3: null,
        mod1_4: null,
        mod1_5: null,
      },
      classNames: {
        diag_1: "",
        diag_2: "",
        diag_3: "",
        diag_4: "",
        diag_5: "",
        proc_code_1: "",
        proc_code_2: "",
        proc_code_3: "",
        proc_code_4: "",
        proc_code_5: "",
        units_1: "",
        units_2: "",
        units_3: "",
        units_4: "",
        units_5: "",
        charge_1: "",
        charge_2: "",
        charge_3: "",
        charge_4: "",
        charge_5: "",
        mod1_1: "",
        mod1_2: "",
        mod1_3: "",
        mod1_4: "",
        mod1_5: ""
      }
    };
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.data !== this.props.data) {
      let fields = Object.assign({}, this.state.fields);
      _.each(fields, (val, key) => {
        fields[key] = (nextProps.data[key] === null) ? null : nextProps.data[key]
      })
      this.setState({ claim: nextProps.data, fields , line_items: nextProps.data.line_items});
      this.highlightErrors(nextProps.data)
    }
  };
  handleOnChange = (event, field) => {
    let currentFields = Object.assign({}, this.state.fields);
    currentFields[field] = event.target.value;

    const index = _.findIndex(this.state.claim.error, error => {
      return error._attributes.fields === field;
    })
    if (index !== -1) {   //remove errors if the current field is in the errors obj
      this.state.claim.error.splice(index, 1)
    }
    this.highlightErrors(this.state.claim);
    this.setState({ fields: currentFields });
    this.claimFieldsCheck(currentFields);
    this.props.getLineItems(currentFields, this.state.claim.error, this.state.line_items);
  }

  claimFieldsCheck = (currentFields) => {
    let claimError = Object.assign([], this.state.claim.error)
    const allFields = currentFields;
    if (claimError === null) {
      claimError = [];
    }
    _.each(allFields, (val, key) => {
      const lineItemNum = (key.substring(key.length - 1));
      if (lineItemNum <= this.state.claim.line_items && val === "" && !key.includes("mod")) {
        const err = {
          _attributes: {
            fields: key,
            mesgid: "NULL",
            message: convertFieldName(key) + " cannot be empty",
            status: "R"
          }
        };
        claimError.push(err);

      }
    });
    claimError = _.uniq(claimError, err => {//to limit num of err for each field to 1
      return err._attributes.fields;
    })
    if (!_.isEqual(claimError, this.state.claim.error)) {
      let newClaim = this.state.claim;
      newClaim.error = claimError;
      this.highlightErrors(newClaim);
      this.setState({ claim: newClaim })
    }

  };
  highlightErrors = (claim) => {
    if (claim !== null) {
      let classNames = _.create("", this.state.classNames);

      _.each(classNames, (val, key) => {  //resetting classNames
        classNames[key] = "";
      })

      _.each(claim.error, error => {
        classNames[error._attributes.fields] = " claim-input-error" //highlighting error ones
      })
      if (!_.isEqual(classNames, this.state.classNames)) {
        this.setState({ classNames })
      }
    }

  }
  addNewItem = () => {
    const claim = Object.assign({}, this.state.claim);
    if (claim.line_items > 4) {
      toastr.error("Max number of line items reached");
    } else {
      claim.line_items = parseInt(claim.line_items,10) + 1;
      this.setState({ claim, line_items: claim.line_items })
      this.props.getLineItemCount(claim.line_items)
    }
  };

  deleteLineItem = (i) => {
    //document.getElementById("line_items_" +i).remove();
    let fields = Object.assign({}, this.state.fields);
    fields["diag_" + i] = null
    fields["proc_code_" + i] = null
    fields["units_" + i] = null
    fields["charge_" + i] = null
    fields["mod1_" + i] = null

    let claim = Object.assign({}, this.state.claim)
    claim.line_items = claim.line_items - 1;
    claim["diag_" + i] = ""
    claim["proc_code_" + i] = ""
    claim["units_" + i] = ""
    claim["charge_" + i] = ""
    claim["mod1_" + i] = ""

    this.setState({ fields, claim , line_items: claim.line_items})
    this.props.getLineItemCount(claim.line_items)

  }


  renderDynamicLineItems = claim => {
    let itemsArr = [];
    for (let j = 1; j <= claim.line_items; j++) {
      itemsArr.push(j);
    }
    return _.map(itemsArr, (claim, i) => {
      return (
        <div key={i} id={"line_items_" + (i + 1)}>
          
         <label htmlFor={"diag_1"}>Diagnosis Code</label>
          <input
          readOnly  
            autoComplete="off"
            className={"claim-input claim-input-small" + this.state.classNames["diag_1"]}
            type="text"
            id={"diag_1"}
            onChange={e => this.handleOnChange(e, "diag_1")}
            value={this.state.fields["diag_1"]}
          />  
         
          <label htmlFor={"proc_code_" + (i + 1)}>Procedure Code</label>
          <input
            autoComplete="off"
            className={"claim-input claim-input-small" + this.state.classNames["proc_code_" + (i + 1)]}
            type="text"
            id={"proc_code_" + (i + 1)}
            onChange={e => this.handleOnChange(e, "proc_code_" + (i + 1))}
            value={this.state.fields["proc_code_" + (i + 1)]}
          />

          <label htmlFor={"mod1_" + (i + 1)}>Modifier</label>
          <input
            autoComplete="off"
            className={"claim-input claim-input-small" + this.state.classNames["mod1_" + (i + 1)]}
            type="text"
            id={"mod1_" + (i + 1)}
            onChange={e => this.handleOnChange(e, "mod1_" + (i + 1))}
            value={this.state.fields["mod1_" + (i + 1)]}
          />
          <label htmlFor={"units_" + (i + 1)}>Units</label>
          <input
            autoComplete="off"
            className={"claim-input claim-input-small" + this.state.classNames["units_" + (i + 1)]}
            type="text"
            id={"units_" + (i + 1)}
            onChange={e => this.handleOnChange(e, "units_" + (i + 1))}
            value={this.state.fields["units_" + (i + 1)]}
          />
          <label htmlFor={"charge_" + (i + 1)}>Charge</label>
          <input
            autoComplete="off"
            className={"claim-input claim-input-small" + this.state.classNames["charge_" + (i + 1)]}
            type="text"
            id={"charge_" + (i + 1)}
            onChange={e => this.handleOnChange(e, "charge_" + (i + 1))}
            value={this.state.fields["charge_" + (i + 1)]}
          />
          {/* {(i!==0)&&<img
            alt="Delete File"
            src={img}
            onClick={() => this.deleteLineItem(i + 1)}
            className="icon-cancel"
            name="times-circle-o"
          />} */}
        </div>
      );
    });
  };

  render() {
    const claim = this.state.claim;
    if (claim === null) {
      return (
        <div></div>
      )
    }
    return (
      <div>
        <fieldset className="line-item" id="line-item-group">
          {this.renderDynamicLineItems(claim)}
          {/* <button className="add-line-item-btn" type="button" onClick={this.addNewItem}>
            + Add New Line Item
          </button> */}
        </fieldset>
      </div>
    );
  }
}

export default LineItem;






// WEBPACK FOOTER //
// ./src/app/common/cms_1500/LineItem.js